export default "/wsteth-eth.fa94136eb46d7bb5436ec3f6c29b1729.svg";